const initialState = {
    username: '',
    email: '',
    _id: '',
    createdAt: '',
    updatedAt: '',
    __v: 0,
    logged: false,
};

export default function homeReducer(state = initialState, action) {
    switch (action.type) {
        case 'CHANGE_INFOS_USER':
            return action.infos;
        case 'LOGOUT':
            return {
                username: '',
                email: '',
                _id: '',
                createdAt: '',
                updatedAt: '',
                __v: 0,
                logged: false,
            };
        default:
            return state
    }
}

export const actions = {
    setIfosUser: (infos) => (
        { type: 'CHANGE_INFOS_USER', infos: infos }
    ),
    handleSignOut: (history) => {
        localStorage.removeItem('token')
        history.push('/')
        return { type: 'LOGOUT' }
    }
}